import React from "react";
import ReactDOM from "react-dom";
import UserPreferencesDialog from "component/molecules/userPreferencesDialog";
import { inject, observer } from "mobx-react";
import Config from "config";

@inject("dialogStore")
@inject("hotkeyStore")
@observer
class UserPreferencesDialogContainer extends React.PureComponent {
  handleRequestClose() {
    const { dialogStore } = this.props;
    dialogStore.setUserPreferencesDialog(false);
  }
  render() {
    const { dialogStore, hotkeyStore } = this.props;
    const customHotKeyMap = hotkeyStore.getHotkeys() || {};
    const defaultHotKeyMap = hotkeyStore.getDefaultHotkeys();
    const show = dialogStore.getUserPreferencesDialog();

    return (
      <UserPreferencesDialog
        show={show}
        defaultHotKeyMap={defaultHotKeyMap}
        customHotKeyMap={customHotKeyMap}
        hasCloseButton={true}
        onRequestClose={this.handleRequestClose.bind(this)}
      />
    );
  }
}

export default UserPreferencesDialogContainer;
